import React from "react";
import PropTypes from "prop-types";
import { sendErrorToSentry } from "./sendErrorToSentry";
import DefaultEvents from "avo/events/global";

class _ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: {},
            errorInfo: null,
            eventId: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        const eventId = sendErrorToSentry(error, errorInfo);
        this.setState({ hasError: true, error, errorInfo, eventId }, () => {
            DefaultEvents.ErrorMessageDisplayedB2b(JSON.stringify({
                eventId,
                error: error?.message,
                stack: error?.stack,
                errorInfo
            }));
        });
    }

    render() {
        const { hasError } = this.state;
        if (hasError) {
            return (
                <div className="text-center"><strong>Uh-oh! Something went wrong. <button type="button" onClick={() => { window.location.reload(true); }} style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0, font: 'inherit'}}>Refresh this page</button> or try again later.</strong></div>
            )
        }

        return this.props.children;
    }
}

_ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired
};

export default _ErrorBoundary;
